import "core-js/stable"
import "regenerator-runtime/runtime"
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store/store'
import 'realgrid/dist/realgrid-style.css'
import RouterTab from 'vue-router-tab'
import 'vue-router-tab/dist/lib/vue-router-tab.css'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import vuetify from './plugins/vuetify'
import "vuetify/dist/vuetify.min.css";
import common from './assets/js/common'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import VueTreeList from 'vue-tree-list'
import Dialog from 'vue-dialog-loading'
import OZViewer from './components/OZViewer.vue'
import dayjs from 'dayjs'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import VueCookies from "vue-cookies"

const options = {
  confirmButtonColor: '#f1286d',
  cancelButtonColor: '#f1286d',
  confirmButtonText: 'Close'
};

let filter = function (text, length, clamp) {
  clamp = clamp || '...'
  let node = document.createElement('div')
  node.innerHTML = text
  let content = node.textContent
  return content.length > length ? content.slice(0, length) + clamp : content
}
Vue.filter('truncate', filter)
Vue.use(VueCookies)
Vue.$cookies.config("7d");
Vue.component('multiselect', Multiselect)
Vue.component('dayjs', dayjs)
Vue.component(OZViewer.name, OZViewer)
Vue.use(VueSweetalert2, options)
Vue.use(RouterTab)
Vue.use(common)
Vue.use(VueQuillEditor)
Vue.use(VueTreeList)
Vue.use(Dialog, { dialogBtnColor: '#0f0' })

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
